import React from 'react';

const GMATUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Math, verbal, and data insights</li>
      <li>Practice tests</li>
      <li>200+ video lessons</li>
      <li>Score increase guarantee</li>
      <li>800+ practice questions</li>
      <li>MBA admissions support</li>
    </ul>
  );
};

export default GMATUpsellContent;
